export const isDocAutoDeleted = (doc) => !!doc.fileAutoDeletedAt
